import { render, staticRenderFns } from "./ai-cover.vue?vue&type=template&id=173883de&scoped=true"
import script from "./ai-cover.vue?vue&type=script&lang=js"
export * from "./ai-cover.vue?vue&type=script&lang=js"
import style0 from "./ai-cover.vue?vue&type=style&index=0&id=173883de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173883de",
  null
  
)

export default component.exports